export const CATALOG_OUTPUT_PROFILE_FOLDER_A4_FLAT = 'folder_a4_flat';

export const CATALOG_OUTPUT_PROFILES = [CATALOG_OUTPUT_PROFILE_FOLDER_A4_FLAT];

export const catalogOutputProfileI18nKey = (profile) => {
  if (profile === CATALOG_OUTPUT_PROFILE_FOLDER_A4_FLAT) {
    return 'catalog.templates.output_profile_folder_a4_flat';
  }
  return 'catalog.templates.output_profile';
};
